import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';
import { create } from 'lodash';

const baseURL = 'production';

const productionService = {
  getProductions: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productions`,
      data,
    });
  },

  getProductionsForStore: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/prodForStore`,
      data,
    });
  },

  createProduction: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateProduction: (data, productionId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(productionId)}`,
      data,
    });
  },

  deleteProduction: (data, productionId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(productionId)}`,
      data,
    });
  },

  deleteProductionReport: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/prodReport/${encodeURIComponent(id)}`,
    });
  },

  getProductionInfo: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionreport/search`,
      data,
    });
  },

  createProductionReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionreport`,
      data,
    });
  },

  simpleUpdateProdReport: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/simpleReport/prodReport`,
      data,
    });
  },

  updateProductionReport: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/prod/prodReport`,
      data,
    });
  },

  updateProductionOperationMultiResource: (resourceOneId, prodOperationId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/productionOperationMultiResource/${encodeURIComponent(resourceOneId)}/${encodeURIComponent(prodOperationId)}`,
    });
  },

  getProductionReports: (prodOperationId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionreports/${encodeURIComponent(prodOperationId)}`,
      data,
    });
  },

  getProductionInfoById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/productionInfo/${encodeURIComponent(id)}`,
    });
  },

  getProductionById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  printDocument: async (data) => {
    const pdf = await request({
      responseType: 'blob',
      method: Methods.POST,
      resource: `${baseURL}/print`,
      data,
    });

    return downloadFile(pdf, pdf.filename);
  },

  updateStatus: (data) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/status`,
      data,
    });
  },

  updateProdOperationResource: (id, resourceOneId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/resource/${encodeURIComponent(id)}/${encodeURIComponent(resourceOneId)}`,
    });
  },

  updateProdOperationResources: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/resources/multiMove`,
      data,
    });
  },

  updateProductionFromStore: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/production/prodStore`,
      data,
    });
  },

  updateVisOrderYBatch: (data) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/productionOperation/visOrderY`,
      data,
    });
  },

  getProductionByOrderNumber: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionByOrderNumber`,
      data,
    });
  },

  getProdutionIssues: (prodId) => {
    return request({
      resource: `${baseURL}/issues/${encodeURIComponent(prodId)}`,
    });
  },

  getProductionReceipts: (prodId) => {
    return request({
      resource: `${baseURL}/receipts/${encodeURIComponent(prodId)}`,
    });
  },

  createProductionIssue: (data, prodId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/issueForProduction/${encodeURIComponent(prodId)}`,
      data,
    });
  },

  createProductionReturn: (data, prodId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/returnFromProduction/${encodeURIComponent(prodId)}`,
      data,
    });
  },

  createProductionReceipt: (data, prodId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/receiptFromProduction/${encodeURIComponent(prodId)}`,
      data,
    });
  },

  getProductionReturnData: (prodId, itemCode) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/prodreturndata/${encodeURIComponent(prodId)}/${encodeURIComponent(itemCode)}`,
    });
  },

  getBreakByUserId: (resourceOneId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/break/${encodeURIComponent(resourceOneId)}`,
    });
  },

  searchProds: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/search`,
      data,
    });
  },

  checkItemForProdReturn: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/checkItemForProdReturn`,
      data,
    });
  },
};

export default productionService;
